<template>
  <div>
    <div class="course-details-section">
      <b-container v-if="dataIsHere" class="py-5">
        <!-- pageIsLoading/ -->
        <div v-if="pageIsLoading" class="text-center text-brand my-5 py-5 loadingBox">
          <b-spinner class="align-middle"></b-spinner>
        </div>
        <b-card v-if="!pageIsLoading" class="course-card">
          <b-row>
            <b-col cols="12">
              <h3 class="course-title">{{ data.name }}</h3>
            </b-col>
            <b-col cols="12">
              <img :src="data.image || placeholderImage" :alt="data.name" class="card-img-top img-fluid"
                style="object-fit: cover;" />
            </b-col>
            <b-col cols="12">
              <div class="course-details">
                <p class="course-details-title"><b>تفاصيل الدورة</b></p>
                <p class="course-details-description" v-html="data.description"></p>
              </div>
              <div class="course-specifications">
                <b-row>
                  <b-col cols="12" md="6">
                    <i class="fa fa-money mx-1"></i> السعر: <course-price :course="data" />
                  </b-col>
                  <b-col cols="12" md="6">
                    <i class="fa fa-clock-o mx-1"></i> عدد الساعات: <strong>{{ data.hours_count }} ساعة</strong>
                  </b-col>
                  <b-col cols="12" md="6">
                    <i class="fa fa-calendar mx-1"></i> تاريخ الدورة: <strong>{{ data.start_date }}</strong>
                  </b-col>
                  <!-- <b-col cols="6">
                    <i class="fa fa-list mx-1"></i> مدة الدورة بالأيام: <strong>{{
                      data.duration }}</strong>
                  </b-col> -->
                </b-row>
              </div>
            </b-col>
            <b-col v-if="data.preview_video_link" cols="12" class="text-center mt-4">
              <b-button :href="data.preview_video_link" target="_blank" rel="noopener noreferrer"
                aria-label="مشاهدة الفيديو التعريفي" variant="outline-brand" class="preview-video-btn">
                <i class="fa fa-play-circle mx-1"></i> مشاهدة الفيديو التعريفي
              </b-button>
            </b-col>
            <div v-if="isAuth" class="w-100">
              <b-col v-if="!data.is_paid" cols="12" class="text-center mt-5">
                <b-button aria-label="اشترك الان" @click="getPayURl(data.id)" variant="brand">اشترك الان</b-button>
              </b-col>
              <b-col v-if="data.is_paid" cols="12" class="text-center mt-5">
                <b-button aria-label="الدروس" @click="goToRoute('courseContent')" variant="brand"> الدروس</b-button>
              </b-col>
            </div>
            <div v-else class="w-100">
              <b-col cols="12" class="text-center mt-5">
                <b-button aria-label="تسجيل الدخول" @click="goTologin('login')" variant="brand">انشئ حسابك او سجل
                  الدخول</b-button>
              </b-col>
            </div>

          </b-row>
        </b-card>
      </b-container>
    </div>
  </div>
</template>

<script>

import { sendRequest } from "../utils/RequestHelper.js";
import placeholderImg from '@/assets/images/placeholder.png';
import CoursePrice from "../components/courses/CoursePrice.vue";
import store from "../store/index.js";

export default {
  name: "CoursesDetails",
  components: { CoursePrice },
  data() {
    return {
      courseId: null,
      data: {},
      placeholderImg,
      pageIsLoading: false,
      isAuth: store.getters.authToken ? true : false,
      dataIsHere: true,
      
    }
  },
  methods: {  
    getPayURl(id) {
      this.pageIsLoading = true;
      sendRequest('post', 'payments/course/' + this.$route.params.id + '/payment/', true, {},
        (data) => {
          this.data = data;
          window.location.href = data.iframe_url
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
        }
      );
    },

    goToRoute(route) {
      this.$router.push({ name: route, params: { id: this.courseId } });
    },
    goTologin() {
      this.$router.push({
        name: "login",
        query: {
          redirect: this.$route.fullPath
        }
      })
    },

    loadData() {
      this.pageIsLoading = true;
      let isAuth = store.getters.authToken ? true : false
      sendRequest('get', 'courses/courses/' + this.$route.params.id, isAuth, null,
        (data) => {
          this.data = data;
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
        }
      );
    }
  },
  created() {
    this.courseId = this.$route.params.id
    this.loadData();
  }
};
</script>

<style scoped>
.course-details-section {
  padding: 30px 20px;
  background-color: #f5f5f5;
}

.course-card {
  padding: 20px 60px;
  border: none;
}

.course-image {
  object-fit: contain;
}

.course-title {
  font-size: 35px;
  font-weight: bold;
  margin-bottom: 20px;
}

.course-details {
  font-size: 21px;
  margin-top: 40px;
}
.course-details-description {
  white-space: pre-line;
}

.course-specifications {
  margin-top: 40px;
  font-size: 21px;
}

/* tablet */
@media (max-width: 991.98px) {
  .course-card {
    padding: 20px 24px;
  }

  .course-title {
    font-size: 28px;
  }

  .course-details,
  .course-specifications {
    font-size: 18px;
    margin-top: 24px;
  }
}

/* mobile */
@media (max-width: 575.98px) {
  .course-details-section {
    padding: 16px 0;
  }

  .course-card {
    padding: 8px 0;
  }

  .course-title {
    font-size: 22px;
  }

  .course-details,
  .course-specifications {
    font-size: 16px;
  }
}
</style>
